import {
  CreateTradeSections,
  ErrorInputTypes,
  TradeTypes,
} from "@shared/features/tradingTerminal/common/types";
import {
  LanguageNameSpaces,
  OrderBaseline,
  OrderTypes,
  TriggerType,
} from "@shared/types";
import { ErrorTypes } from "@shared/features/trades/common/types";
import {
  NUMBER_OF_ORDERS_ITEM_NAME,
  TRAILING_PERCENT_ITEM_NAME,
  TRAILING_STOP_TYPE_ITEM_NAME,
  TRIGGER_TYPE_ITEM_NAME,
  TRIGGER_VALUE_ITEM_NAME,
} from "@shared/features/configuration/constants";
import {
  ENTRIES_HELPER_TOOLTIP,
  STOP_HELPER_TOOLTIP,
  TAKE_PROFITS_HELPER_TOOLTIP,
} from "@shared/common/Tooltips/constants";
import { invert } from "lodash";
import { TranslationKeys } from "@shared/common/i18n/types";

export const ORDER_TYPE_TO_CREATE_TRADE_TAB = {
  [OrderTypes.ENTRY]: CreateTradeSections.ENTRIES,
  [OrderTypes.TAKE_PROFIT]: CreateTradeSections.TAKE_PROFITS,
  [OrderTypes.STOP]: CreateTradeSections.STOP,
};

export const ORDER_TYPE_TO_STRATEGY_ITEM_NAME = {
  [OrderTypes.ENTRY]: "Entry Strategy",
  [OrderTypes.TAKE_PROFIT]: "Take-Profit Strategy",
  [OrderTypes.STOP]: "Stop Strategy",
};

export const DEFAULT_TAKE_PROFIT_NUM_ORDERS = 1;
export const DEFAULT_NUM_ORDERS = 4;
export const DEFAULT_BREAKOUT_ENTRY_NUM_ORDERS = 2;
export const EQUAL_ZONE_PRICES_NUM_ORDERS = 1;

export const DEFAULT_TAKE_PROFIT_PRICE_RANGE_DISTANCE = [5, 10];
export const DEFAULT_BREAKOUT_TAKE_PROFIT_PRICE_RANGE_DISTANCE = [15, 20];
export const DEFAULT_ENTRY_PRICE_RANGE_DISTANCE = [0, 10];
export const DEFAULT_BREAKOUT_ENTRY_PRICE_RANGE_DISTANCE = [5, 10];

export const TRADING_TERMINAL_PADDING = 20;
export const MOBILE_TRADING_TERMINAL_PADDING = 12;

export const TRADE_TYPE_TO_DISPLAY_NAME = {
  [TradeTypes.REGULAR]: "Regular",
  [TradeTypes.BREAKOUT]: "Breakout",
};

export const TRADE_DEFAULT_STOP = {
  percent: "5",
  baseline: OrderBaseline.LAST_ENTRY,
};

export const TRADING_TERMINAL_OLD_VERSION_KEY = "trading_terminal_old_version";

export const TRIGGER_TYPE_TO_DISPLAY_NAME: Record<
  TriggerType,
  TranslationKeys<LanguageNameSpaces.TRADING_TERMINAL>
> = {
  [TriggerType.TARGET]: "labels.target",
  [TriggerType.PERCENT]: "labels.percent",
};

export const ON_CHANGE_WARNING_MESSAGE = "modals.confirm_data_loss";

export const ORDER_KEY_TO_ERROR_TYPES: Record<ErrorInputTypes, ErrorTypes[]> = {
  price: [
    ErrorTypes.DUPLICATE_PRICE,
    ErrorTypes.LONG_ENTRY_ABOVE_TAKE_PROFIT,
    ErrorTypes.SHORT_ENTRY_BELOW_TAKE_PROFIT,
    ErrorTypes.LONG_TAKE_PROFIT_BELOW_ENTRIES,
    ErrorTypes.SHORT_TAKE_PROFIT_ABOVE_ENTRIES,
    ErrorTypes.LONG_STOP_ABOVE_ENTRIES,
    ErrorTypes.SHORT_STOP_BELOW_ENTRIES,
    ErrorTypes.LONG_BREAKOUT_ENTRY_BELOW_CURRENT_PRICE,
    ErrorTypes.SHORT_BREAKOUT_ENTRY_ABOVE_CURRENT_PRICE,
    ErrorTypes.INVALID_ORDER_PRICE,
  ],
  percent: [ErrorTypes.SUM_OF_RATIOS, ErrorTypes.INVALID_ORDER_RATIO],
  amount: [ErrorTypes.INVALID_ENTRY_ORDER_AMOUNT],
};

export const DEFAULT_AMOUNT_RATIO_FROM_AVAILABLE_AMOUNT = 0.05;
export const PERCENT_PRECISION = 2;

export const GENERAL_OPTION_NAME_TO_CREATE_TRADE_KEY: Record<string, string> = {
  "long/short": "reverse",
  "trade type": "trade_type",
  "margin type": "margin_type",
  multiplier: "leverage",
  "cancel on first target reached": "cancel_on_first_target_reached",
};

export const CREATE_TRADE_KEY_TO_GENERAL_OPTIONS_NAME: Record<string, string> =
  {
    ...invert(GENERAL_OPTION_NAME_TO_CREATE_TRADE_KEY),
    signal_type: "signal type",
  };

export const SELECT_ITEMS = [
  NUMBER_OF_ORDERS_ITEM_NAME,
  TRAILING_STOP_TYPE_ITEM_NAME,
  TRAILING_PERCENT_ITEM_NAME,
  TRIGGER_TYPE_ITEM_NAME,
  TRIGGER_VALUE_ITEM_NAME,
];

export const ORDER_TYPE_TO_TOOLTIP = {
  [OrderTypes.ENTRY]: ENTRIES_HELPER_TOOLTIP,
  [OrderTypes.TAKE_PROFIT]: TAKE_PROFITS_HELPER_TOOLTIP,
  [OrderTypes.STOP]: STOP_HELPER_TOOLTIP,
};

export const NEW_CUSTOM_STRATEGY_VALUE = "custom";

export const ORDER_PRICE_RANGE_MULTIPLIER = 20;

export const DEFAULT_SIGNAL_AMOUNT = "5";
export const CANCEL_ON_PROFIT_BEFORE_ENTRY_TITLE =
  "tooltips.close_on_tp_before_entry";

export const ORDER_TYPE_TO_TRAILING_TITLE: Record<
  OrderTypes,
  TranslationKeys<LanguageNameSpaces.TRADING_TERMINAL>
> = {
  [OrderTypes.ENTRY]: "trailing.entry",
  [OrderTypes.TAKE_PROFIT]: "trailing.take_profit",
  [OrderTypes.STOP]: "trailing.stop",
};
